<mat-tab-group (selectedTabChange)="onTabChange($event)">
    <mat-tab label="Profile">
        <h1>{{(user$ | async)?.alias}}</h1>
        <h3>Email Preferences</h3>
        <p>
            We send emails periodically for the below items. You can subscribe to as many or as few as you like. Note that you cannot unsubscribe
            from certain emails, such as notifications about the status of your account or subscription, or if you request support from us.
        </p>
        <form [formGroup]="emailSubscriptionsChange" class="vertical-flex-container">
            <ng-container formArrayName="emailSubscriptions">
                <div *ngFor="let _ of emailSubscriptionsControls.controls; index as i">
                    <mat-checkbox [formControlName]="i">{{possibleEmailSubscriptions[i].name}}</mat-checkbox>
                </div>
            </ng-container>
            <button class="quarter-wide padded" mat-raised-button color="accent" type="button" (click)="onUpdateEmailPreferencesSubmit(false)" gtagEvent trackOn="click" action="change_email_subscriptions" category="account" [params]="{ use_id: authService.currentUserId }">Update Preferences</button>
            <button class="quarter-wide padded" mat-raised-button color="warn" type="button" (click)="onUpdateEmailPreferencesSubmit(true)" gtagEvent trackOn="click" action="change_email_subscriptions" category="account" [params]="{ use_id: authService.currentUserId }">No emails!</button>
        </form>
    </mat-tab>
    <mat-tab label="Security">
        <form [formGroup]="passwordChange" (submit)="onChangePasswordSubmit()" class="vertical-flex-container">
            <mat-form-field class="quarter-wide">
                <mat-label>Current Password</mat-label>
                <input formControlName="currentPass" matInput type="password" required>
            </mat-form-field>
            <mat-form-field class="quarter-wide">
                <mat-label>New Password</mat-label>
                <input formControlName="newPass" matInput type="password" required>
            </mat-form-field>
            <div class="error" *ngIf="passwordChange.controls['newPass'].invalid && (passwordChange.controls['newPass'].touched || passwordChange.controls['newPass'].dirty)">
                <mat-error *ngIf="passwordChange.controls['newPass'].errors?.minlength">Password must be at least 8 characters.</mat-error>
            </div>
            <mat-form-field class="quarter-wide">
                <mat-label>Confirm Password</mat-label>
                <input formControlName="confirmNewPass" matInput type="password" required>
            </mat-form-field>
            <div *ngIf="passwordChange.controls['confirmNewPass'].invalid && (passwordChange.touched || passwordChange.dirty)">
                <mat-error *ngIf="passwordChange.controls['confirmNewPass'].errors?.controlValueIsSame">New password fields do not match.</mat-error>
                <mat-error *ngIf="passwordChange.controls['confirmNewPass'].errors?.minlength">Password must be at least 8 characters.</mat-error>
            </div>
            <button class="quarter-wide" mat-raised-button color="accent" type="submit" gtagEvent trackOn="click" action="change_password" category="account" [params]="{ user_id: authService.currentUserId }">Change Password</button>
        </form>
    </mat-tab>
    <mat-tab label="Subscription">
        <h1>Current Subscription Level: {{subscriptionLevel}}</h1>
        <form *ngIf="showCardFields; else subscriberButtons" [formGroup]="subscriptionChange" (submit)="subscriptionChangeSubmit()" class="vertical-flex-container">
            <h3>Update Card Details</h3>
            <mat-form-field class="quarter-wide">
                <input formControlName="fullName" matInput placeholder="Full Name">
            </mat-form-field>
            <div id="cardElement" class="quarter-wide"></div>
            <div class="error quarter-wide" *ngIf="cardError">
                <mat-error>{{cardError}}</mat-error>
            </div>
            <div *ngIf="stripeError" class="quarter-wide">
                <mat-error>{{stripeError}}</mat-error>
            </div>
            <div class="form-footer">
                <a href="https://stripe.com"><img class="processor-badge" alt="Powered By Stripe" src="assets/stripe/PoweredByStripe{{themeIsLightColor ? 'Blurple' : 'White'}}.png"></a>
            </div>
            <button class="quarter-wide padded" mat-raised-button color="accent" type="submit">{{userHasSubscription ? 'Change Subscription Level' : 'Subscribe now!'}}</button>
            <button *ngIf="userHasSubscription" class="quarter-wide padded" mat-raised-button color="warn" type="button" (click)="setShowCardFields(false)">Cancel</button>
        </form>
        <ng-template #subscriberButtons>
            <div *ngIf="!showConfirmCancellation; else confirmCancellation" class="vertical-flex-container">
                <div *ngIf="stripeLast4; else noCardDataOnFile" class="horizontal-flex-container">
                    <div class="card-on-file">Card on file: ************{{stripeLast4}}</div>
                    <div>Exp {{stripeExpMonth}}/{{stripeExpYear}}</div>
                </div>
                <ng-template #noCardDataOnFile>
                    <p>
                        We don't have any card data on file for you.
                    </p>
                </ng-template>
                <button class="quarter-wide padded" mat-raised-button color="accent" type="button" (click)="setShowCardFields(true)">Update card details</button>
                <button class="quarter-wide padded" mat-raised-button color="warn" type="button" (click)="showConfirmCancellation = true">Cancel subscription</button>
            </div>
        </ng-template>
        <ng-template #confirmCancellation>
            <div class="vertical-flex-container">
                <h3>Cancel Subscription</h3>
                <p class="quarter-wide">
                    Are you sure you want to cancel you subscription? If you cancel, you'll lose any subscription-lifetime
                    discounts you currently have.
                </p>
                <button class="quarter-wide padded" mat-raised-button color="accent" type="button" (click)="showConfirmCancellation = false">Keep subscription</button>
                <button class="quarter-wide padded" mat-raised-button color="warn" type="button" (click)="cancelSubscription()">Really cancel subscription</button>
            </div>
        </ng-template>
    </mat-tab>
</mat-tab-group>
